var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup9102(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1266_340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7801 15.2196C32.6394 15.079 32.4487 15 32.2498 15C32.051 15 31.8602 15.079 31.7196 15.2196L23.9998 22.9393L16.2801 15.2196C16.1394 15.079 15.9487 15 15.7498 15C15.551 15 15.3602 15.079 15.2196 15.2196V15.2196C15.079 15.3602 15 15.551 15 15.7498C15 15.9487 15.079 16.1394 15.2196 16.2801L22.9393 23.9998L15.2196 31.7196C15.079 31.8602 15 32.051 15 32.2498C15 32.4487 15.079 32.6394 15.2196 32.7801V32.7801C15.3602 32.9207 15.551 32.9997 15.7498 32.9997C15.9487 32.9997 16.1394 32.9207 16.2801 32.7801L23.9998 25.0603L31.7196 32.7801C31.8602 32.9207 32.051 32.9997 32.2498 32.9997C32.4487 32.9997 32.6394 32.9207 32.7801 32.7801C32.9207 32.6394 32.9997 32.4487 32.9997 32.2498C32.9997 32.051 32.9207 31.8602 32.7801 31.7196L25.0603 23.9998L32.7801 16.2801C32.9207 16.1394 32.9997 15.9487 32.9997 15.7498C32.9997 15.551 32.9207 15.3602 32.7801 15.2196V15.2196Z",
    fill: "#314155"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1266_340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup9102);
export default __webpack_public_path__ + "static/media/Group 9102.579f8fe4.svg";
export { ForwardRef as ReactComponent };